<template>
  <div class="bind_bank_box">
    <div class="tips">
      <img src="@/assets/warn_icon.png" />
      <span>银行卡持卡人姓名、身份证号必须与实名认证提交的信息一致</span>
    </div>
    <!-- <div class="content_box" v-if="type==2">
      <van-form ref="bindBankCardRef">
        <van-field
          v-model="bindBankCardForm.bankCardNo"
          name="个人银行卡号"
          label="个人银行卡号(可选)"
          placeholder="请输入"
        />
        <van-field
          v-model="bindBankCardForm.bankName"
          name="持卡人姓名"
          label="持卡人姓名(可选)"
          placeholder="请输入"
        />
        <van-field
          v-model="bindBankCardForm.bankIdentityNo"
          name="持卡人身份证号"
          label="持卡人身份证号(可选)"
          placeholder="请输入"
        />
      </van-form>
    </div> -->
    <div class="content_box">
      <van-form ref="bindingCardRef">
        <van-field
          v-model="bindingCardForm.bankName"
          :name="type==2?'持卡人姓名':'真实姓名'"
          :label="type==2?'持卡人姓名':'真实姓名'"
          placeholder="请输入"
          :required="type==2?false:true"
          :rules="[{ required: type==2?false:true, message: type==2?'请填写持卡人姓名':'请填写真实姓名' }]"
        />
        <van-field
          v-model="bindingCardForm.bankIdentityNo"
          :name="type==2?'持卡人身份证号':'身份证号'"
          :label="type==2?'持卡人身份证号':'身份证号'"
          placeholder="请输入"
          :required="type==2?false:true"
          :rules="[{ required: type==2?false:true, message: type==2?'请填写持卡人身份证号':'请填写身份证号' }]"
        />
        <van-field
          v-model="bindingCardForm.bankCardNo"
          :name="type==2?'个人银行卡号':'银行卡号'"
          :label="type==2?'个人银行卡号':'银行卡号'"
          placeholder="请输入"
          :required="type==2?false:true"
          :rules="[{ required: type==2?false:true, message: type==2?'请填写个人银行卡号':'请填写银行卡号' }]"
        />
        <van-field
          v-model="bindingCardForm.bankPhone"
          label="联系电话"
          placeholder="请输入"
          :required="type==2?false:true"
          :rules="[{ required: true, message: '请填写联系电话' }]"
        >
          <template #button>
            <div
              class="code"
              :style="{ color: codeDisable ? '#999999' : '#3377ff' }"
              @click="sendCode"
            >
              {{ codeBtnStr }}
            </div>
          </template>
        </van-field>
        <van-field
          v-model="bindingCardForm.verificationCode"
          name="短信验证码"
          label="短信验证码"
          placeholder="请输入"
          :required="type==2?false:true"
          :rules="[{ required: true, message: '请填写短信验证码' }]"
        />
      </van-form>
    </div>
    <!-- <div class="promote-box">
      <div class="promoteTitle">特别说明：</div>
      <div class="promoteDesc">
        银行卡持卡人姓名、身份证号必须与实名认证提交的信息一致
      </div>
    </div> -->
    <div style="margin: 16px;">
      <van-button
        type="info"
        @click="onSubmit"
        block
        :loading="bindBankLoading"
      >
        提交
      </van-button>
    </div>
    <van-dialog
			v-model="show"
			title=""
			show-cancel-button
			get-container="body"
			@confirm="confirmDialog"
			@cancel="cancelDialog"
      confirm-button-text="查看详情"
      cancel-button-text="去首页"
      confirm-button-color="#1989fa"
      cancel-button-color="#1989fa"
		>
			<div class="bind-bank-success">
        <img src="@/assets/bind-success.png" class="bind-success-img" />
				<div>绑定成功！</div>
			</div>
		</van-dialog>
  </div>
</template>
<script>
import {
  qfmemberBindBankCard,
  getInfoById,
  getUserQfRegisterInfo,
  getEnterpriseInfo
} from '@/api/user';
import { isPhone } from "@/utils/validate";
export default {
  data() {
    return {
      // 企业绑定银行卡参数
      // bindBankCardForm: {
      //   bankCardNo: '', // 银行卡号
      //   bankName: '', // 持卡人姓名
      //   bankIdentityNo: '', // 持卡人身份证
      // },
      // 个人绑定银行卡参数
      bindingCardForm: {
        bankCardNo: '', // 银行卡号
        bankName: '', // 持卡人姓名
        bankIdentityNo: '', // 持卡人身份证号
        bankPhone: '', // 持卡人手机号
        verificationCode: '', // 短信验证码
      },
      type: null, // 会员类型 : 企业会员2 个人会员3
      isSuccess: false, // 是否已经绑定银行卡
      bindBankLoading: false,
      show: false, // 绑定成功弹窗
      codeBtnStr: "获取验证码",
      time: 120,
      codeDisable: false,
    }
  },
  created() {
    // if (this.$route.query.type) {
    //   this.type = this.$route.query.type;
    // }
    if (this.$route.query.isSuccess) {
      this.isSuccess = JSON.parse(this.$route.query.isSuccess);
      this.show = this.isSuccess;
    }
    getUserQfRegisterInfo().then(res => {
      if (res.code === 200) {
        // userType为【0管理员1分销商员工】 userType为【2分销员】
        // classify 1企业 2个人
        let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
        if (res.data.userType == '0' || res.data.userType == '1') {
          this.type = 2;
          if (res.data.classify == '1') {
            // 获取信息是为了回填
            this.getEnterpriseInfo();
          } else if (res.data.classify == '2') {
            // 获取信息是为了回填
            this.getInfoById(userInfo_v2.identity.distributorId);
          }
        } else if (res.data.userType == '2') {
          this.type = 3;
          // 获取信息是为了回填
          this.getInfoById(userInfo_v2.user.userId);
        }
      }
    })
  },
  methods: {
    // 获取个人清分信息
    getInfoById(tempId) {
      getInfoById(tempId).then(res => {
        if (res.code === 200) {
          this.bindingCardForm = {
            bankCardNo: '', // 银行卡号
            bankName: res.data.user.name || '', // 持卡人姓名
            bankIdentityNo: res.data.user.identityNo || '', // 持卡人身份证号
            bankPhone: res.data.user.phone || '', // 持卡人手机号
            verificationCode: '', // 短信验证码
          };
        }
      })
    },
    // 企业
    getEnterpriseInfo() {
      let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
      getEnterpriseInfo(userInfo_v2.identity.distributorId).then(res => {
        if (res.code === 200) {
          this.bindingCardForm = {
            bankCardNo: '', // 银行卡号
            bankName: res.data.company.iegalName || '', // 持卡人姓名
            bankIdentityNo: res.data.company.iegalIds || '', // 持卡人身份证号
            bankPhone: res.data.company.iegalPhone || '', // 持卡人手机号
            verificationCode: '', // 短信验证码
          };
        }
      })
    },
    sendCode() {
      if (this.codeDisable) {
        return;
      }
      if (!isPhone(this.bindingCardForm.bankPhone)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      this.codeDisable = true;
      let interval = setInterval(() => {
        this.codeBtnStr = this.time + "s";
        this.time -= 1;
        if (this.time === 0) {
          this.codeBtnStr = "获取验证码";
          this.time = 120;
          this.codeDisable = false;
          clearInterval(interval);
        }
      }, 1000);
      this.codeRequest(this.bindingCardForm.bankPhone);
    },
    codeRequest(phone) {
      let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
      var id = this.type == 2 ? userInfo_v2.identity.distributorId : userInfo_v2.user.userId;
      this.$API.user
        .qfmemberSendCode(id, phone)
        .then((res) => {});
    },
    onSubmit() {
      const userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
      let id = '';
      if (this.type == 2) {// 企业
        id = userInfo_v2.identity.distributorId;
      } else if (this.type == 3) {// 个人
        id = userInfo_v2.user.userId;
      }
      this.$refs.bindingCardRef.validate().then(() => {
        this.bindBankLoading = true;
        qfmemberBindBankCard(id, this.bindingCardForm).then(res => {
          if (res.code === 200) {
            this.show = true;
            this.bindBankLoading = false;
          }
        }).catch(() => {
          this.bindBankLoading = false;
        })
      })
    },
    confirmDialog() {
      this.$router.push({
        path: "/registerDetail",
      });
    },
    cancelDialog() {
      this.$router.push({
        path: "/index",
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.bind_bank_box {
  // padding: vw(20);
  .tips {
    width: 100%;
    background: #FFF2F2;
    font-size: vw(24);
    display: flex;
    align-items: center;
    padding: vw(20) vw(30);
    color: #FF3333;
    img {
      width: vw(26);
      height: vw(26);
      margin-right: vw(8);
    }
  }
}
.promote-box {
  margin: vw(32);
  margin-left: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: #D9001B;
  font-size: vw(30);
  .promoteDesc {
    flex: 1;
    color: #333;
  }
}
.bind-bank-success {
  padding: vw(60) 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: vw(30);
  font-weight: bold;
  color: #2E3033;
  .bind-success-img {
    width: vw(140);
    height: vw(140);
    margin-bottom: vw(40);
  }
}
</style>